import "core-js/modules/es6.object.assign";
import React from 'react';
import { Link } from 'gatsby';
import { rhythm, scale } from '../utils/typography';
var Layout = function Layout(_ref) {
    var location = _ref.location, title = _ref.title, children = _ref.children;
    var rootPath = __PATH_PREFIX__ + "/";
    var header;
    if (location.pathname === rootPath) {
        header = /*#__PURE__*/ React.createElement("h1", {
            style: Object.assign({}, scale(1.5), {
                marginBottom: rhythm(1.5),
                marginTop: 0
            })
        }, /*#__PURE__*/ React.createElement(Link, {
            style: {
                boxShadow: "none",
                color: "inherit"
            },
            to: "/"
        }, title));
    }
    else {
        header = /*#__PURE__*/ React.createElement("h3", {
            style: {
                fontFamily: "Montserrat, sans-serif",
                marginTop: 0
            }
        }, /*#__PURE__*/ React.createElement(Link, {
            style: {
                boxShadow: "none",
                color: "inherit"
            },
            to: "/"
        }, title));
    }
    return /*#__PURE__*/ React.createElement("div", {
        style: {
            marginLeft: "auto",
            marginRight: "auto",
            maxWidth: rhythm(32),
            padding: rhythm(1.5) + " " + rhythm(3 / 4)
        }
    }, /*#__PURE__*/ React.createElement("header", null, header), /*#__PURE__*/ React.createElement("main", null, children), /*#__PURE__*/ React.createElement("footer", {
        style: {
            textAlign: 'center'
        }
    }, "\xA9 ", new Date().getFullYear(), " kubio.dev, Built with", " ", /*#__PURE__*/ React.createElement("a", {
        href: "https://www.gatsbyjs.org"
    }, "Gatsby")));
};
export default Layout;
